import { AssessmentInfo, Icf } from "../assessment";
import { Task, TaskPointScoring } from "../scoring/scoring";
import { SumScoring } from "../scoring/sumScoring";

export const fgaInfo: AssessmentInfo = {
    shortName: "FGA",
    fullName: "Functional Gait Assessment",
    reportDescription: `\
<p>Das Functional Gait Assessment (FGA) ist ein standardisierter Test zur objektiven Bewertung der Gehfähigkeit unter verschiedenen Bedingungen. Er wird häufig bei Patienten eingesetzt, die ein erhöhtes Sturzrisiko aufweisen, z. B. nach neurologischen oder orthopädischen Erkrankungen. Der Test umfasst 10 Aufgaben, die verschiedene Anforderungen an das Gleichgewicht, die Stabilität und die Gangkontrolle stellen.</p>`,
    entryReference: `\
<ul>
    <li>3 Punkte: Normal</li>
    <li>2 Punkte: Leichte Schädigung</li>
    <li>1 Punkte: Mäßige Schädigung</li>
    <li>0 Punkte: Schwere Schädigung</li>
</ul>`
}

export const fgaTaskList: Task[] = [
    { name: "Gehen auf einer Ebene", icfCategories: ["d450"] },
    { name: "Wechseln der Geschwindigkeit", icfCategories: ["d450"] },
    { name: "Gang mit horizontaler Kopfdrehung", icfCategories: ["d450"] },
    { name: "Gang mit vertikaler Kopfdrehung", icfCategories: ["d450"] },
    { name: "Gang und Drehung um 180°", icfCategories: ["d450"] },
    { name: "Übersteigen eines Hindernisses", icfCategories: ["d4502"] },
    { name: "Gehen mit schmaler Unterstützungsfläche", icfCategories: ["d455"] },
    { name: "Gang mit geschlossenen Augen", icfCategories: ["d455"] },
    { name: "Rückwärtsgehen", icfCategories: ["d455"] },
    { name: "Treppe", icfCategories: ["d4551"] },
]

export const fgaScoreMapping = [
    Icf.Level3, // 0 points
    Icf.Level2, // 1 points
    Icf.Level1, // 2 points
    Icf.Level0, // 3 points
]

export const fgaScoringInfo: TaskPointScoring = {
    scoreMapping: fgaScoreMapping,
    sided: false,
    tasks: fgaTaskList
}

export const fgaScoring = SumScoring.fromScoringInfo(fgaScoringInfo);